import React from 'react';
import { useSelector } from 'react-redux';
import IconTarget from '../../shared/icons/IconTarget';

const SelectTarget = () => {
  const selectedtarget = useSelector(
    state => state.deDistribute.selectedTarget
  );
  const distRequest = useSelector(state => state.deDistribute.distRequest);
  const distErrors = useSelector(state => state.deDistribute.distErrors);
  const targetName = selectedtarget ? selectedtarget.name : '';
  const targetStudy = selectedtarget ? selectedtarget.study : '';

  let isDisabled = true;
  if (!distRequest.status || distRequest.status === 'Draft') {
    isDisabled = false;
  }

  let targetClass = 'distro__row distro__target';
  if (isDisabled) {
    targetClass += ' distro__row distro__target--disabled';
  }

  const noTargetMessage =
    'You must select a target to make a distribution request';

  return (
    <div className={targetClass}>
      <div className="distro__card">
        <div className="distro__card__icon">
          <IconTarget fill="#ffffff" />
        </div>
        <div className="distro__card__body">
          {selectedtarget ? (
            <div className="distro__card__copy">
              <h4 className="distro__tartet--title">{targetName}</h4>
              <p className="distro__tartet--study">{targetStudy}</p>
            </div>
          ) : (
            <div className="distro__card__copy">
              <div className="distro__card__no-target">{noTargetMessage}</div>
            </div>
          )}
          {distErrors.isTargetErr && (
            <div className="distro__card--error">
              {distErrors.isTargetErrMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectTarget;
